<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户类型：</span>
        </div>
        <div>
          <el-select v-model="formData.model" placeholder="请选择" size="mini" style="width: 280px">
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <b class="red">*</b>
          <span class="line-text">商户号：</span>
        </div>
        <el-input type="text" v-model="formData.mchId" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户名称：</span>
        </div>
        <el-input type="text" v-model="formData.mchName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户密钥：</span>
        </div>
        <el-input type="text" v-model="formData.mchKey" size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-if="formData.model === '2'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">特约商商户号：</span>
        </div>
        <el-input type="text" v-model="formData.subMchId" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">用途：</span>
        </div>
        <div>
          <el-select v-model="formData.purpose" placeholder="请选择" size="mini" style="width: 280px">
            <el-option
              v-for="item in purposeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/Config'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'wx-account-add',
    data () {
      return {
        breadcrumb: [{
          value: '配置中心',
          name: 'config-basic'
        }, {
          value: '微信账户配置'
        }],
        mainTitle: '添加微信账户',
        subheading: '',

        formData: {
          model: '1',
          mchId: '',
          mchName: '',
          mchKey: '',
          subMchId: '',
          purpose: '1'
        },

        modelList: [
          {
            value: '1',
            label: '普通商户'
          }, {
            value: '2',
            label: '服务商户'
          }
        ],

        purposeList: [
          {
            value: '1',
            label: '人脸'
          }, {
            value: '2',
            label: '物业'
          }, {
            value: '3',
            label: '维修'
          }, {
            value: '4',
            label: '停车'
          }, {
            value: '5',
            label: '场地'
          }, {
            value: '6',
            label: '电费'
          }, {
            value: '9',
            label: '水费'
          }, {
            value: '8',
            label: '空调费'
          }, {
            value: '7',
            label: '租金'
          }
        ]
      }
    },
    created () {

    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'wx-account-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.mchId) {
          nError('请输入商户号')
          return false
        }
        if (!this.formData.mchName) {
          nError('请输入商户名称')
          return false
        }
        if (!this.formData.mchKey) {
          nError('请输入商户密钥')
          return false
        }
        if (this.formData.model === '2' && !this.formData.subMchId) {
          nError('请输入特约商商户号')
          return false
        }
        this.$axios.post(api.addWxDepositAccountPage, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ConfigCenter/wxAccountConfig/wxAccountAdd.vue